import styled from 'styled-components';

import { ReactComponent as Timer } from '../../assets/icons/timer.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 28px 0;

  .title {
    width: 180px;
    height: 28px;
    margin-bottom: 20px;
  }

  .subtitle {
    width: 390px;
    height: 20px;
    margin-bottom: 26px;
  }

  .contract {
    width: 624px;
    height: 96px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 960px) {
    border-radius: 0;
    margin-top: 0;
    padding-bottom: 0;

    .title {
      width: 155px;
    }

    .subtitle {
      width: 335px;
    }

    .contract {
      width: 335px;
    }
  }
`;
export const Container = styled.div`
  width: 624px;
  padding: 20px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;
export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 8px;
  text-align: center;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 28px;
  line-height: 130%;
  text-align: center;

  @media screen and (max-width: 960px) {
    font-size: 16px;
    margin-bottom: 28px;
    text-align: center;
  }
`;

export const Content = styled.div`
  width: 100%;
  min-height: 98px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  margin-bottom: 12px;

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 16px;
    flex-wrap: wrap;
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;

  .number {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 20px;
  }

  .bank-name {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
  }

  .default {
    font-weight: 400;
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;

    .bold {
      font-weight: 700;
    }
  }

  .default2 {
    font-weight: 400;
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
    min-width: 200px;

    .bold {
      font-weight: 700;
      font-size: 14px;
    }
  }

  .space-right {
    margin-right: 4px;
  }

  .debt-description {
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
  }

  @media screen and (max-width: 960px) {
    width: 66%;
    .number {
      font-size: 20px;
    }

    .bank-name {
      font-size: 14px;
    }

    .default {
      order: 2;
      font-size: 12px;
    }

    .default2 {
      order: 1;
      font-size: 12px;
    }

    div {
      margin-left: 4px;
    }
  }
`;

export const DiscountContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '5px'};
    height: 48px;
    width: 88px;
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    font-size: 11px;
    padding: 8px;
    font-weight: 400;
    text-align: center;

    span {
      font-size: 21px;
      font-weight: 700;
    }
  }

  @media screen and (max-width: 960px) {
    order: 3;
    div {
      margin-top: 8px;
      width: auto;
      height: auto;
      padding: 8px 12px;

      span {
        font-size: 14px;
      }
    }
  }
`;

export const IconContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    margin-top: 6px;
    font-weight: 400;
    font-size: 12px;
  }

  @media screen and (max-width: 960px) {
    div {
      width: 60px;
      text-align: center;
      font-size: 12px;
    }
  }
`;

export const IconTimer = styled(Timer)`
  width: 28px;
  height: 24px;
`;

export const ContractDescription = styled.span`
  margin-left: 16px;
  word-wrap: break-word;
  padding-top: 4px;

  @media screen and (max-width: 960px) {
    padding-top: 2px;
  }
`;
